import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _SeverityLevels, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";

export const SeverityLevels = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_SeverityLevels);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }
        instance.getSeverityLevelsCatalogPorPropiedades(props, null).then((resp: any) => {
            setLista(resp);
        }).catch(err => {
            toast.error("Error al cargar la lista de Severidades");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Severidad`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateSeverityLevels(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDSeverityLevels', visible: true },
        { title: 'Severidad', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Severidad de las fallas o mantenimientos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre de la Severidad</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`} >Descripción</label>
                                <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}